import {
    Selector as PropsSelector,
    Link as PropsLink,
    Layout as PropsLayout,
} from '@/models/Props';

import './Link.scss';

const Link = ({
    dataAttb,
    href,
    children,
}: PropsLink & PropsLayout & PropsSelector) => {
    return (
        <a
            className={'link'}
            href={href}
            target='_blank'
            rel='noreferrer'
            {...dataAttb}
        >
            {children}
        </a>
    );
};

export default Link;
